import React from 'react';
import { Header, Message } from 'semantic-ui-react';
import { Card } from './Card';
import { LiveValue } from './LiveValue';
import { Segment } from './Segment';

interface OutputProps {
	callback: () => string;
}

export const Output: React.FC<OutputProps> = ({ callback }) => {
	return (
		<Segment basic>
			<Card>
					<Header as="h2">This is what you get &hellip;</Header>
					<Message info size="large">
						<LiveValue callback={callback} />
					</Message>
			</Card>
		</Segment>
	);
};
